import { Authenticator } from '@aws-amplify/ui-react';
import { css } from '@styled/css';
import { Box, Flex } from '@styled/jsx';

import DeveloperMenu from './components/DeveloperMenu';
import StatusIndicator from './components/StatusIndicator';

type GenericRecord = Record<string, unknown>;

function getDisplayNameFromUser(user: unknown): string | undefined {
  if (user && typeof user === 'object') {
    const record = user as GenericRecord;
    const attributesUnknown = record.attributes;
    if (attributesUnknown && typeof attributesUnknown === 'object') {
      const attributes = attributesUnknown as GenericRecord;
      const name = attributes.name;
      const email = attributes.email;
      if (typeof name === 'string') return name;
      if (typeof email === 'string') return email;
    }
    const username = record.username;
    if (typeof username === 'string') return username;
  }
  return undefined;
}

function App() {
  return (
    <Authenticator loginMechanisms={['email']}>
      {({ signOut, user }) => (
        <Flex
          direction="column"
          minH="100vh"
          bg="#f8fafc"
        >
          <header
            className={css({
              bg: 'linear-gradient(135deg, #1e40af 0%, #3b82f6 100%)',
              color: 'white',
              position: 'sticky',
              top: 0,
              zIndex: 100,
              boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
            })}
          >
            <nav
              className={css({
                display: 'flex',
                alignItems: 'center',
                px: 6,
                py: 4,
                gap: 4,
                maxW: '1400px',
                mx: 'auto',
                w: '100%',
              })}
            >
              <Box
                fontWeight="bold"
                fontSize="lg"
              >
                WebAdmin
              </Box>
              <Box flex="1" />
              <StatusIndicator />
              <DeveloperMenu />
              {(() => {
                const displayName = getDisplayNameFromUser(user);
                return displayName ? (
                  <span
                    className={css({
                      bg: 'rgba(255, 255, 255, 0.2)',
                      backdropFilter: 'blur(4px)',
                      color: 'white',
                      px: 4,
                      py: 1.5,
                      borderRadius: 'full',
                      fontSize: 'sm',
                      fontWeight: 'medium',
                    })}
                  >
                    {displayName}
                  </span>
                ) : null;
              })()}
              <button
                onClick={signOut}
                className={css({
                  bg: 'rgba(255, 255, 255, 0.15)',
                  border: '1px solid rgba(255, 255, 255, 0.3)',
                  color: 'white',
                  px: 5,
                  py: 2,
                  borderRadius: 'md',
                  cursor: 'pointer',
                  fontSize: 'sm',
                  fontWeight: 'medium',
                  transition: 'all 0.2s',
                  _hover: {
                    bg: 'rgba(255, 255, 255, 0.25)',
                    borderColor: 'white',
                    transform: 'translateY(-1px)',
                  },
                })}
              >
                Logout
              </button>
            </nav>
          </header>

          <main
            className={css({
              p: 8,
              flex: 1,
              maxW: '1400px',
              mx: 'auto',
              w: '100%',
            })}
          >
            <Box
              bg="white"
              borderRadius="xl"
              boxShadow="0 1px 3px rgba(0,0,0,0.1)"
              p={8}
            >
              {(() => {
                const displayName = getDisplayNameFromUser(user);
                return (
                  <h1
                    className={css({
                      fontSize: '2xl',
                      fontWeight: 'bold',
                      color: '#1e293b',
                      mb: 2,
                    })}
                  >
                    Welcome{displayName ? `, ${displayName}` : ''}
                  </h1>
                );
              })()}
              <p className={css({ color: '#64748b', fontSize: 'md' })}>
                You are logged in and ready to go.
              </p>
            </Box>
          </main>
        </Flex>
      )}
    </Authenticator>
  );
}

export default App;
